(() => {
  if (window.ProductBlockVariantDan) {
    return;
  }

  const SELECTORS = {
    card: '.product-block',
    mainAtc: '[data-product-block-atc-dan]',
    layer: '[data-product-block-variant-layer-dan]',
    pill: '[data-product-block-variant-pill-dan]',
    confirm: '[data-product-block-variant-confirm-dan]',
    close: '[data-product-block-variant-close-dan]',
    error: '[data-product-block-variant-error-dan]'
  };

  const STATE = {
    openCard: null
  };

  function getCard(element) {
    return element?.closest(SELECTORS.card) || null;
  }

  function getLayer(card) {
    return card?.querySelector(SELECTORS.layer) || null;
  }

  function getMainButton(card) {
    return card?.querySelector(SELECTORS.mainAtc) || null;
  }

  function getConfirmButton(card) {
    return card?.querySelector(SELECTORS.confirm) || null;
  }

  function getErrorElement(card) {
    return card?.querySelector(SELECTORS.error) || null;
  }

  function clearError(card) {
    const error = getErrorElement(card);

    if (!error) {
      return;
    }

    error.hidden = true;
    error.textContent = '';
  }

  function showError(card, message) {
    const error = getErrorElement(card);

    if (error) {
      error.textContent = message;
      error.hidden = false;
      return;
    }

    const mainButton = getMainButton(card);

    if (
      window.theme?.showQuickPopup &&
      window.jQuery &&
      mainButton
    ) {
      window.theme.showQuickPopup(message, window.jQuery(mainButton));
      return;
    }

    console.error(message);
  }

  function resetSelection(card) {
    card?.querySelectorAll(SELECTORS.pill).forEach((pill) => {
      pill.classList.remove('is-selected');
      pill.setAttribute('aria-pressed', 'false');
    });

    const confirmButton = getConfirmButton(card);

    if (confirmButton) {
      confirmButton.disabled = true;
      delete confirmButton.dataset.variantId;
    }
  }

  function closeSheet(card, restoreFocus = false) {
    if (!card) {
      return;
    }

    const layer = getLayer(card);
    const mainButton = getMainButton(card);

    if (layer) {
      layer.classList.remove('is-open');
      layer.setAttribute('aria-hidden', 'true');
    }

    if (mainButton) {
      mainButton.setAttribute('aria-expanded', 'false');
    }

    resetSelection(card);
    clearError(card);

    if (STATE.openCard === card) {
      STATE.openCard = null;
    }

    if (restoreFocus && mainButton) {
      mainButton.focus();
    }
  }

  function openSheet(card) {
    const layer = getLayer(card);

    if (!layer) {
      return;
    }

    if (STATE.openCard && STATE.openCard !== card) {
      closeSheet(STATE.openCard);
    }

    resetSelection(card);
    clearError(card);

    layer.classList.add('is-open');
    layer.setAttribute('aria-hidden', 'false');

    const mainButton = getMainButton(card);

    if (mainButton) {
      mainButton.setAttribute('aria-expanded', 'true');
    }

    STATE.openCard = card;

    requestAnimationFrame(() => {
      card.querySelector(SELECTORS.pill)?.focus();
    });
  }

  function selectVariant(pill) {
    const card = getCard(pill);

    if (!card) {
      return;
    }

    card.querySelectorAll(SELECTORS.pill).forEach((otherPill) => {
      const selected = otherPill === pill;
      otherPill.classList.toggle('is-selected', selected);
      otherPill.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    const confirmButton = getConfirmButton(card);

    if (!confirmButton) {
      return;
    }

    confirmButton.dataset.variantId = pill.dataset.variantId;
    confirmButton.disabled = false;
    clearError(card);
  }

  function getCartAddUrl() {
    return window.theme?.routes?.cart_add_url || '/cart/add.js';
  }

  async function requestAddToCart(variantId) {
    const body = new URLSearchParams();
    body.set('id', String(variantId));
    body.set('quantity', '1');
    body.set('sections', 'cart-drawer');

    const response = await fetch(getCartAddUrl(), {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: body.toString()
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(
        data.description ||
        data.message ||
        'No se pudo agregar el producto al carrito.'
      );
    }

    return data;
  }

  function dispatchCartChanged() {
    document.documentElement.dispatchEvent(
      new CustomEvent('theme:cartchanged', {
        bubbles: true,
        cancelable: false
      })
    );
  }

  function setLoading(button, loading) {
    if (!button) {
      return;
    }

    if (loading) {
      if (!button.dataset.previousHtml) {
        button.dataset.previousHtml = button.innerHTML;
      }

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.innerHTML = '<div class="loading-spinner loading-spinner--in-btn"></div>';
      return;
    }

    button.removeAttribute('aria-busy');

    if (button.dataset.previousHtml) {
      button.innerHTML = button.dataset.previousHtml;
    }

    button.disabled = false;
  }

  function flashAdded(card) {
    const button = getMainButton(card);

    if (!button) {
      return;
    }

    const originalHtml =
      button.dataset.originalHtml ||
      button.dataset.previousHtml ||
      button.innerHTML;

    button.dataset.originalHtml = originalHtml;
    button.disabled = true;
    button.classList.add('is-added');
    button.textContent = 'AGREGADO ✓';

    window.clearTimeout(Number(button.dataset.addedTimer || 0));

    const timer = window.setTimeout(() => {
      button.innerHTML = button.dataset.originalHtml || 'Agregar al carrito';
      button.disabled = false;
      button.classList.remove('is-added');
      delete button.dataset.addedTimer;
    }, 3000);

    button.dataset.addedTimer = String(timer);
  }

  async function addVariant(card, variantId, actionButton, closeAfterSuccess) {
    if (!card || !variantId || card.dataset.productBlockAddingDan === 'true') {
      return;
    }

    card.dataset.productBlockAddingDan = 'true';
    clearError(card);
    setLoading(actionButton, true);

    try {
      await requestAddToCart(variantId);

      if (closeAfterSuccess) {
        closeSheet(card);
      }

      dispatchCartChanged();
      flashAdded(card);

      document.dispatchEvent(
        new CustomEvent('product-block:added', {
          detail: {
            productId: card.dataset.productId || '',
            variantId: String(variantId)
          }
        })
      );
    } catch (error) {
      showError(
        card,
        error instanceof Error
          ? error.message
          : 'No se pudo agregar el producto al carrito.'
      );

      setLoading(actionButton, false);
    } finally {
      delete card.dataset.productBlockAddingDan;
    }
  }

  function handleMainAtc(button) {
    const card = getCard(button);

    if (!card) {
      return;
    }

    const variantCount = Number(button.dataset.variantCount || 0);

    if (variantCount > 1) {
      openSheet(card);
      return;
    }

    addVariant(
      card,
      button.dataset.directVariantId,
      button,
      false
    );
  }

  function handleConfirm(button) {
    const card = getCard(button);

    if (!card || !button.dataset.variantId) {
      return;
    }

    addVariant(
      card,
      button.dataset.variantId,
      button,
      true
    );
  }

  document.addEventListener(
    'click',
    (event) => {
      const mainAtc = event.target.closest(SELECTORS.mainAtc);

      if (mainAtc) {
        event.preventDefault();
        event.stopPropagation();
        handleMainAtc(mainAtc);
        return;
      }

      const pill = event.target.closest(SELECTORS.pill);

      if (pill) {
        event.preventDefault();
        event.stopPropagation();
        selectVariant(pill);
        return;
      }

      const confirmButton = event.target.closest(SELECTORS.confirm);

      if (confirmButton) {
        event.preventDefault();
        event.stopPropagation();
        handleConfirm(confirmButton);
        return;
      }

      const closeButton = event.target.closest(SELECTORS.close);

      if (closeButton) {
        event.preventDefault();
        event.stopPropagation();
        closeSheet(getCard(closeButton), true);
      }
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && STATE.openCard) {
      closeSheet(STATE.openCard, true);
    }
  });

  window.ProductBlockVariantDan = {
    closeAll() {
      if (STATE.openCard) {
        closeSheet(STATE.openCard);
      }
    }
  };
})();
